import React, { useEffect, useState } from 'react';
import Moment from 'moment';
import AddressService from "services/Address";
import StorageService from 'services/StorageService';
import CartService from 'services/Cart';
import PubSub from "services/PubSub";
import { actionsType } from 'config/constants';
import AddressFactory from 'factories/Address';
import Tooltip from 'components/Tooltip';
import {useIsMounted} from 'hooks';
import style from './style.scss';//NOSONAR

let actions = {};

const BannerHour = (props) => {
    const id = props && props.id ? props.id : 0;
    const method = StorageService.getItem('preselected_shipping_method');
    const [timeExpress, setTimeExpress] = useState('');
    const [date, setDate] = useState(null);
    const [shippingCost, setShippingCost] = useState('');
    const isMounted = useIsMounted();

    useEffect(() =>{
        getDateDelivery();

    }, []);

    useEffect(() =>{
        if(!actions[id]){
            actions[id] = [];
        }
        actions[id].push(PubSub.register(actionsType.SET_SALES_CHANNEL, getDateDelivery));


        return function cleanup() {
            actions[id].map(token => PubSub.unregister(token));
            actions[id] = [];
        }

    }, []);

    const getDateDelivery = () => {
        const address = StorageService.getSecureItem('address');
        const sc = StorageService.getSecureItem('sales_channel');
        const method = StorageService.getItem('preselected_shipping_method');
        const formatMethod = AddressFactory.getFormatedMethod(method);
        const methodTranslate = trasnlateMethod(method);
        setShippingCost(methodTranslate);

        if(method === 'seller-1-sla-Express') {
            setTimeExpress(CartService._expressTime())

        } else {
            AddressService.getHoursDelivery(address, sc, formatMethod).then((results) => {
                if(isMounted.current){
                    setDate(results.data.sla);
                }
            })
        }
    }

    const trasnlateMethod = (method) => {
        switch(method){
            case 'seller-1-sla-RetiroenTienda':
                return "Costo de retiro";
            case 'seller-1-sla-ClickalAuto':
                return "Costo de retiro";
            case 'seller-1-sla-DespachoaDomicilio':
                return "Costo de despacho";
            case 'seller-1-sla-Express':
                return "Costo de despacho";
            default:
                return '';
        }
    }

    const formatDate = (date) => {
        if(!date) return false;
        const dayName = Moment(date.startDateUtc).locale('es').format('ddd DD');
        let newDay = dayName.charAt(0).toUpperCase() + dayName.slice(1).replace('.', '');
        const month = Moment(date.startDateUtc).locale('es').format('MM');
        const newMonth = month.charAt(0).toUpperCase() + month.slice(1);
        const hour = Moment(date.startDateUtc).utc().format('HH:mm');

        if(Moment(dayName).locale('es').format('YYYY-MM-DD') === Moment().locale('es').format('YYYY-MM-DD')) {
            return 'Hoy' + ' a las ' + hour + ' hrs';
        }else {
            return newDay + '/' + newMonth + ' - ' + hour + ' hrs';
        }

    }

    const priceFormat = (number) => (number && number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.'));

    if(!date) return '';

    return(
        <div className="banner-hour-container" >
            <Tooltip message='Encuentra aquí la <strong>referencia</strong> del próximo horario de entrega' button='Entendido' timer={10000} once={true} type='tooltip_hour_info'>
                <div className ="banner-hour-items-container">
                    <div className="banner-shipping-wrapper">
                        <span className="banner-hour-span">{shippingCost}</span>
                        <span className="items-price">{ '$' + priceFormat(date.listPrice)}</span>
                    </div>
                    <span className="item-split-bar">|</span>
                    <div className="banner-hour-wrapper">
                        <span className="banner-hour-span">Desde</span>
                        <span className="banner-hour-date">{(method === 'seller-1-sla-Express') ? `${timeExpress} minutos`: formatDate(date) }</span>
                    </div>
                </div>
            </Tooltip>
        </div>
    )
}

export default BannerHour;
